const asyncActionType = type => ({
  pending: `${type}_PENDING`,
  success: `${type}_SUCCESS`,
  error: `${type}_ERROR`
});

export const DOCUMENT_LIST = asyncActionType('aerosimple/settings/DOCUMENT_LIST');
export const DOCUMENT_CREATE = asyncActionType('aerosimple/settings/DOCUMENT_CREATE');
export const GET_DOCUSIGN = asyncActionType('aerosimple/settings/GET_DOCUSIGN');
export const DOCUMENT_TYPES = asyncActionType('aerosimple/settings/DOCUMENT_TYPES');
export const GET_DOC_SIGNED_URL = asyncActionType('aerosimple/settings/GET_DOC_SIGNED_URL');
